/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Scope_PastInputs */

const en_admin_resources_resource_allocations_scope_past = /** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past`)
};

const de_admin_resources_resource_allocations_scope_past = /** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückliegend`)
};

const es_admin_resources_resource_allocations_scope_past = /** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasadas`)
};

const fr_admin_resources_resource_allocations_scope_past = /** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passées`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_PastInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_scope_past = en_admin_resources_resource_allocations_scope_past;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_PastInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_scope_past = en_admin_resources_resource_allocations_scope_past;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_PastInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_scope_past = en_admin_resources_resource_allocations_scope_past;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_PastInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_scope_past = en_admin_resources_resource_allocations_scope_past;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Scope_PastInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_scope_past = en_admin_resources_resource_allocations_scope_past;

/**
* | output |
* | --- |
* | "Past" |
*
* @param {Admin_Resources_Resource_Allocations_Scope_PastInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_scope_past = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Scope_PastInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Scope_PastInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_scope_past(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_scope_past(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_scope_past(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_scope_past(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_scope_past(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_scope_past(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_scope_past(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_scope_past(inputs)
	return ro_admin_resources_resource_allocations_scope_past(inputs)
});
export { admin_resources_resource_allocations_scope_past as "admin.resources.resource_allocations.scope_past" }